/* eslint-disable react-hooks/exhaustive-deps */

import { WMS_PBF_PO } from "App/constants";
import { isNull } from "App/utils/helpers";
import { useDispatchWrapper } from "hooks";
import React, { createContext, useEffect, useState } from "react";
import { FORM_RESET_STATE_WMS_PO } from "../helpers";

export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const { state } = useDispatchWrapper();

  const [formData, setFormData] = useState(() => {
    if (isNull(state.page_wf_purchase_order)) {
      return FORM_RESET_STATE_WMS_PO;
    } else {
      if (state.wrapper_active_menu === WMS_PBF_PO) {
        return state.page_wf_purchase_order;
      } else {
        return FORM_RESET_STATE_WMS_PO;
      }
    }
  });

  useEffect(() => {
    if (isNull(state.page_wf_purchase_order)) {
      setFormData(FORM_RESET_STATE_WMS_PO);
    } else {
      if (state.wrapper_active_menu === WMS_PBF_PO) {
        setFormData(state.page_wf_purchase_order);
      } else {
        setFormData(FORM_RESET_STATE_WMS_PO);
      }
    }
  }, [state.page_wf_purchase_order]);

  return (
    <FormContext.Provider value={{ formData, setFormData }}>
      {children}
    </FormContext.Provider>
  );
};
